<template>
  <div class="video-config-provider">
  <GenericVideoJSPlayer 
    :globalReference="globalReference" 
    v-bind:options="videoOptionsWithMuxConfig"
    v-bind:chaptersVtt="videoConfig.chapters_vtt_url"
    v-bind:textTracks="videoConfig.text_tracks"
    v-if="hasReadyVideoConfig"> 
  </GenericVideoJSPlayer>
  </div>
</template>

<script>

import axios from 'axios'
import GenericVideoJSPlayer from './GenericVideoJSPlayer'

export default {

  components: {
    GenericVideoJSPlayer
  },

  props: {
    globalReference: {
      type: String,
      required: false
    },
    videoConfigId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      videoConfig: null,
      fetchingVideoConfig: false
    }
  },

  methods: {
    fetchVideoConfig () {
      this.fetchingVideoConfig = true
      axios.get(`/video-configs/${this.videoConfigId}?ajax=1`)
        .then(response => {
          this.videoConfig = response.data
          this.eventAttendeeId = response.data.event_attendee_id
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.fetchingVideoConfig = false
        })
    },
  },

  computed: {
    hasReadyVideoConfig () {
      return this.videoConfig && !!this.videoConfig.videoOptions
    },

    videoOptionsWithMuxConfig () {
      if (!this.videoConfig) return {};
      return Object.assign({}, this.videoConfig.videoOptions, {
        plugins: this.muxConfig
      }) 
    },

    muxConfig: function () {
      return {
        mux: {
          debug: false,
          data: {
            env_key: process.env.MIX_MUX_ENV_KEY,
            video_id: `videoConfig-${this.videoConfigId}`,
            viewer_user_id: this.eventAttendeeId,
            video_title: this.videoConfig.name,
            player_name: 'GenericVideoJSPlayer',
          }
        }
      } 
    },    
  },

  mounted: function () {
    window.VideoConfigProvider = this
    this.fetchVideoConfig()
  }
}

</script>

<style>
  .video-js {
    width: 500px;
    height: 300px;
  }
</style>